import { render, staticRenderFns } from "./PriceCurrencyV.vue?vue&type=template&id=35615f0e&"
import script from "./PriceCurrencyV.vue?vue&type=script&setup=true&lang=js&"
export * from "./PriceCurrencyV.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports